import React from 'react';
import { Form } from 'antd';
import { FilterContentProps } from '../types';
import { TimeRangePicker } from 'components';

export const FilterContentTimeRange = ({ name, onFilterChange }: FilterContentProps) => (
	<Form.Item name={name}>
		<TimeRangePicker showSecond={false} format={'HH:mm'} onChange={onFilterChange} />
	</Form.Item>
);
